const SMARTLING_LOCALES = {
  ar: { name: 'Arabic' },
  'cs-CZ': { name: 'Czech' },
  'da-DK': { name: 'Danish' },
  'de-DE': { name: 'German' },
  'el-GR': { name: 'Greek' },
  'en-US': { name: 'English' },
  'es-ES': { name: 'Spanish' },
  'es-LA': { name: 'Latin American Spanish' },
  'fi-FI': { name: 'Finnish' },
  'fr-CA': { name: 'Québécois' },
  'fr-FR': { name: 'French' },
  'he-IL': { name: 'Hebrew' },
  'hi-IN': { name: 'Hindi' },
  'hu-HU': { name: 'Hungarian' },
  'id-ID': { name: 'Indonesian' },
  'it-IT': { name: 'Italian' },
  'ja-JP': { name: 'Japanese' },
  'ko-KR': { name: 'Korean' },
  'ms-MY': { name: 'Malay' },
  'nb-NO': { name: 'Norwegian' },
  'nl-NL': { name: 'Dutch' },
  'pl-PL': { name: 'Polish' },
  'pt-BR': { name: 'Brazilian Portuguese' },
  'pt-PT': { name: 'Portuguese' },
  'ru-RU': { name: 'Russian' },
  'sv-SE': { name: 'Swedish' },
  'th-TH': { name: 'Thai' },
  'tr-TR': { name: 'Turkish' },
  'uk-UA': { name: 'Ukrainian' },
  'vi-VN': { name: 'Vietnamese' },
  'zh-TW': { name: 'Traditional Chinese' },
};

const createLocaleMap = locales =>
  locales.reduce((localeMap, locale) => ({ ...localeMap, [locale.toLowerCase()]: locale }), {});

const CONSUMER_SMARTLING_LOCALES = createLocaleMap([
  'ar',
  'da-DK',
  'de-DE',
  'el-GR',
  'en-US',
  'es-ES',
  'es-LA',
  'fi-FI',
  'fr-CA',
  'fr-FR',
  'he-IL',
  'hi-IN',
  'hu-HU',
  'id-ID',
  'it-IT',
  'ja-JP',
  'ko-KR',
  'nb-NO',
  'nl-NL',
  'pl-PL',
  'pt-BR',
  'pt-PT',
  'ru-RU',
  'sv-SE',
  'th-TH',
  'tr-TR',
  'uk-UA',
  'vi-VN',
  'zh-TW',
]);

const ARTISTS_SMARTLING_LOCALES = createLocaleMap([
  'ar',
  'cs-CZ',
  'de-DE',
  'el-GR',
  'en-US',
  'es-ES',
  'es-LA',
  'fi-FI',
  'fr-CA',
  'fr-FR',
  'he-IL',
  'hu-HU',
  'id-ID',
  'it-IT',
  'ja-JP',
  'ko-KR',
  'ms-MY',
  'nl-NL',
  'pl-PL',
  'pt-BR',
  'ru-RU',
  'sv-SE',
  'th-TH',
  'tr-TR',
  'vi-VN',
  'zh-TW',
]);

module.exports = {
  ARTISTS_SMARTLING_LOCALES,
  CONSUMER_SMARTLING_LOCALES,
  SMARTLING_LOCALES,
  DEFAULT_LOCALE: 'en-US',
};
